"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "settings.invoicing",
    path: "invoicing",
    component: "SettingsInvoicing"
});
let SettingsInvoicing = class SettingsInvoicing extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    updateItem(...args) {
        const [data, extras] = args;
        return this.$fn.crud('invoicing_settings').update(_.extend(_.pick(data, [
            'company',
            'draft_numbering',
            'numbering',
            'invoicing_mode',
            'invoicing_provider',
            'template'
        ]), extras), {
            parameters: { company_id: data.company.id }
        });
    }
    onSave(...args) {
        const [$event] = args;
        const row = $event.data.row;
        return $event.data.waitFor(this.updateItem(row));
    }
    configureNumbering(...args) {
        const [value, row] = args;
        const updateItem = this.updateItem;
        return this.$imodal
            .show({
            name: 'InvoicingNumbering',
            props: {
                company: row.company,
                oid: value ? value.id : null,
                saving(numbering) {
                    return updateItem(row, { numbering });
                }
            }
        });
    }
    configureProvider(...args) {
        const [value, row] = args;
        const updateItem = this.updateItem;
        return this.$imodal
            .show({
            name: 'InvoicingProviderSettings',
            props: {
                item: _.cloneDeep(value),
                saving(invoicing_provider) {
                    return updateItem(row, { invoicing_provider });
                }
            }
        })
            .then(result => {
            if (result) {
                row.setData(result);
            }
        });
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_invoicing_settings').then(data => _.orderBy(data, ['company.name']).map(p => _.extend(p, { id: p.company.id })));
    }
    numberings;
    async $$load_numberings() {
        return this.$fn.fetch('list_numbering').then(data => _.filter(data, { resource_type: 'invoice:out' }));
    }
    templates;
    async $$load_templates() {
        return this.$fn.fetch('list_template').then(data => _.filter(data, { template_type: 'html', object_type: 'invoice' }));
    }
    invoicingModes;
    async $$load_invoicingModes() {
        return this.$fn.getEnumValuesFromSchema('InvoicingMode');
    }
    ux;
    b_7315092382398562_modalBindings;
    b_3343864469950044_columns;
    async $$load_b_3343864469950044_columns() {
        return [{
                name: "company",
                field: "company.name",
                header: this.$fn.pgettext("Settings|TableHeader", "Company"),
                width: "200px",
                editable: false,
            },
            {
                name: "invoicing_mode",
                header: this.$fn.pgettext("Settings|TableHeader", "Invoicing mode"),
                width: "160px",
                type: "select2",
                options: this.invoicingModes,
                valueField: "value",
                textField: "text",
            },
            {
                name: "draft_numbering",
                header: this.$fn.pgettext("Settings|TableHeader", "Draft numbering"),
                width: "160px",
                type: "select2",
                options: this.numberings,
                textField: "description",
                path: "description",
                bindObject: true,
                clearable: true,
            },
            {
                name: "numbering",
                header: this.$fn.pgettext("Settings|TableHeader", "Numbering"),
                width: "160px",
                editable: false,
                formatter: {
                    name: "template",
                    value: "<a href=\"\" @click.prevent.stop=\"globs.configureNumbering(value, row)\">\n\
  <span class=\"text-nowrap\" v-if=\"value\">\n\
    {{ value.info.last_number }}\n\
  </span>\n\
  <span class=\"text-nowrap\" v-if=\"!value\">\n\
    unset\n\
  </span>\n\
</a>\n\
",
                },
            },
            {
                name: "invoicing_provider",
                header: this.$fn.pgettext("Settings|TableHeader", "Provider settings"),
                width: "160px",
                editable: false,
                formatter: {
                    name: "template",
                    value: "<a href=\"\" @click.prevent.stop=\"globs.configureProvider(value, row)\">\n\
  <span class=\"text-nowrap\" v-if=\"value\">\n\
    {{ value.name }}\n\
  </span>\n\
  <span class=\"text-nowrap\" v-if=\"!value\">\n\
    unset\n\
  </span>\n\
</a>\n\
",
                },
            },
            {
                name: "template",
                header: this.$fn.pgettext("Settings|TableHeader", "Template"),
                width: "160px",
                type: "select2",
                options: this.templates,
                path: "name",
                textField: "name",
                bindObject: true,
                clearable: true,
            },
        ];
    }
    dataMembers = ['items', 'numberings', 'templates', 'invoicingModes', 'ux', 'b_7315092382398562_modalBindings', 'b_3343864469950044_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                numberings: null,
                templates: null,
                invoicingModes: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_3343864469950044_columns: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return;
        }
        return null;
    }
    async act_7315092382398562_closeModal_5594_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3343864469950044_script_5598_getActionArgs_value($event) {
        this.onSave($event);
    }
    async act_3343864469950044_script_5598_getActionArgs($event) {
        return {
            value: () => this.act_3343864469950044_script_5598_getActionArgs_value($event),
        };
    }
    async evh_3343864469950044_save(event, scope) {
        return await this.actions.evh_3343864469950044_save.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5594 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5594_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5593 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5594,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5593],
        });
        const act_8320016629450276_reloadComponentData_5596 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_8320016629450276_clickPreventStop_5595 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadComponentData_5596,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_5595],
        });
        const act_3343864469950044_script_5598 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3343864469950044_script_5598_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_save_5597 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_script_5598,
            event: "save",
            displayName: "script",
        });
        const evh_3343864469950044_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_save_5597],
        });
        return {
            act_7315092382398562_closeModal_5594,
            evh_7315092382398562_close_5593,
            evh_7315092382398562_close,
            act_8320016629450276_reloadComponentData_5596,
            evh_8320016629450276_clickPreventStop_5595,
            evh_8320016629450276_clickPreventStop,
            act_3343864469950044_script_5598,
            evh_3343864469950044_save_5597,
            evh_3343864469950044_save,
            reload: act_8320016629450276_reloadComponentData_5596,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], SettingsInvoicing.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], SettingsInvoicing.prototype, "onSize", null);
SettingsInvoicing = __decorate([
    (0, vue_property_decorator_1.Component)()
], SettingsInvoicing);
exports.default = SettingsInvoicing;
vue_property_decorator_1.Vue.component("SettingsInvoicing", SettingsInvoicing);
